<template>
    <aside class="sidebar">
      <!-- Logo -->
      <router-link  :to="{ name: 'vendor-dashboard' }" class="sidebar-header mt-2 pb-5">
        <img src="@/assets/logo-circle.svg" alt="Logo" class="logo" />
        <span class="brand">Guiders.pt</span>
      </router-link>
  
      <!-- Navigation -->
      <nav class="sidebar-nav">
        <p class="nav-section">OVERVIEW</p>
        <SidebarItem icon="home" label="Home"  link-name="vendor-dashboard"/>
        <SidebarItem v-if="user.role !== ResellerRoles.externalSeller" icon="clipboard-list" label="Sell Tickets" link-name="generate-ticket"/>
        <!-- <SidebarItem icon="fas fa-chart-line" label="Sales" link-name="vendor-sales-table" /> -->
  
        <p class="nav-section">FINANCE</p>
        <SidebarItem icon="fas fa-file-invoice-dollar" label="Transactions" disabled />
        <SidebarItem icon="fas fa-file-invoice" label="Invoices" disabled />
      </nav>
  
      <!-- Footer -->
      <div class="sidebar-footer">
        <SidebarItem icon="fas fa-cog" label="Settings" disabled/>
        <SidebarItem icon="fas fa-question-circle" label="Help" disabled />
        <div @click="signOutUser">
          <SidebarItem icon="fas fa-sign-out-alt" label="Sign out" :isDanger="true" />
        </div>
      </div>
    </aside>
  </template>
  
  <script>
  import {ResellerRoles} from "../enums/ResellerRoles"
  import SidebarItem from "../components/elements/SidebarItem.vue";
  import { mapState , mapActions} from "vuex";
  import { UsersStates , UserActions} from "../store/Storetypes";
  
  export default {
    components: {
      SidebarItem,
    },
    data(){
      return {
        ResellerRoles
      }
    },
    methods: {
      ...mapActions({
      signOut: UserActions.SIGN_OUT,
    }),
      signOutUser() {
        this.$emit("toggleVisibility", false);
        this.signOut();
        this.$router.push({ name: "home" });
      },
    },
    computed: {
      ...mapState({
        user: (state) => state.users[UsersStates.USER],
      }),
    },
  };
  </script>
  
  <style scoped lang="scss">
  .sidebar {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 260px;
    height: 100vh;
    padding: 1rem;
    border-right: 1px solid #eee;
    background: #fff;
  }
  
  .sidebar-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .logo {
    width: 28px;
    height: 28px;
  }
  
  .brand {
    font-weight: 700;
    font-size: 1.1rem;
  }
  
  .sidebar-nav {
    flex-grow: 1;
    margin-top: 1.5rem;
  }
  
  .nav-section {
    font-size: 0.75rem;
    font-weight: 600;
    color: #9ca3af;
    margin: 1rem 0 0.5rem;
  }
  
  .sidebar-footer {
    margin-top: auto;
    padding-top: 1rem;
    border-top: 1px solid #f0f0f0;
  }
  </style>
  